import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  genericError: {
    id: 'masquerade-widget.userName.error.generic',
    defaultMessage: 'An error has occurred; please try again.',
    description: 'Message shown after a general error when attempting to masquerade',
  },
  placeholder: {
    id: 'masquerade-widget.userName.input.placeholder',
    defaultMessage: 'Username or email',
    description: 'Placeholder text to prompt for a user to masquerade as',
  },
  userNameLabel: {
    id: 'masquerade-widget.userName.input.label',
    defaultMessage: 'Masquerade as this user',
    description: 'Label for the masquerade user input',
  },
  noEnrolledUsersFound: {
    id: 'masquerade-widget.userName.search.noResults',
    defaultMessage: 'No enrolled users found',
    description: 'Message shown when no enrolled users match the masquerade search',
  },
  searchingUsers: {
    id: 'masquerade-widget.userName.search.pending',
    defaultMessage: 'Searching users...',
    description: 'Message shown while enrolled user search is loading',
  },
  titleViewAs: {
    id: 'instructor.toolbar.view.as',
    defaultMessage: 'View this course as:',
    description: 'Button to view this course as',
  },
  titleStaff: {
    id: 'instructor.toolbar.staff',
    defaultMessage: 'Staff',
    description: 'Button Staff',
  },
});

export default messages;
